export default () => (
  /**
   * Ícone "checked" com contorno circular
   * com preenchimento na cor verde
   * simbolizando sucesso ou válido
   */
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.605 0.691406C5.08919 0.691406 0.60498 5.17562 0.60498 10.6914C0.60498 16.2072 5.08919 20.6914 10.605 20.6914C16.1208 20.6914 20.605 16.2072 20.605 10.6914C20.605 5.17562 16.1208 0.691406 10.605 0.691406ZM10.605 19.4703C5.76288 19.4703 1.82603 15.5335 1.82603 10.6914C1.82603 5.8493 5.76288 1.91246 10.605 1.91246C15.4471 1.91246 19.3839 5.8493 19.3839 10.6914C19.3839 15.5335 15.4471 19.4703 10.605 19.4703Z"
      fill="#32B797"
    />
    <path
      d="M15.2367 7.53355L9.32089 13.4493L6.31036 10.4388C6.01562 10.1441 5.53141 10.1441 5.23668 10.4388C4.94194 10.7336 4.94194 11.2178 5.23668 11.5125L8.77352 15.0493C8.92089 15.1967 9.11037 15.2809 9.32089 15.2809C9.53142 15.2809 9.72089 15.1967 9.86826 15.0493L16.3104 8.60723C16.6051 8.31249 16.6051 7.82829 16.3104 7.53355C16.0156 7.23882 15.5525 7.23882 15.2367 7.53355Z"
      fill="#32B797"
    />
  </svg>
);
